<!-- Used for refference. Will be removed once the v2 is ready to go live. -->

<template>
  <header class="app-header">
    <b-navbar
      class="app-header__navbar"
      toggleable="md">
      <b-col
        md="12"
        class="navbar-container">
        <b-row
          align-h="start"
          class="mx-0">
          <div>
            <b-navbar-brand
              to="/"
              class="main">
              <img
                class="app-header__logo"
                src="~@/assets/img/sendbee-logo.svg"
                alt="AI Number">
            </b-navbar-brand>
          </div>
          <b-col
            cols="4"
            sm="4"
            class="header-container">
            <nav
              v-click-outside="closeMobileMenu"
              :class="{opened: mobileMenuOpened}"
              class="mobile-menu">
              <scroll-area>
                <BusinessSubmenu v-if="businessNav"/>
                <div class="user-submenu">
                  <div
                    class="open-submenu"
                    @click="toggleUserSubmenu">
                    <span class="user-avatar no-shrink">
                      <span
                        :style="avatar ? `background-image: url(${avatar})` : ''"
                        class="image">
                        {{ avatar ? '' : userName | initials }}
                        <span
                          :class="{green: userAvailable, red: !userAvailable}"
                          class="indicator"/>
                      </span>
                    </span>
                    <span class="name">{{ userName }}</span>
                    <span
                      :class="{opened: userSubmenuOpened}"
                      class="arrow">
                      <icon name="chevron-down"/>
                    </span>
                  </div>
                  <ul
                    v-show="userSubmenuOpened"
                    class="mobile-menu-list">
                    <li class="list-item change-status">
                      <div
                        class="mobile-menu-availability clearfix">
                        <label for="user-availability">
                          <span
                            :class="{green: userAvailable, red: !userAvailable}"
                            class="indicator"/>
                          {{ userAvailable ? 'Available' : 'Away' }}
                        </label>
                        <SwitchCheckbox
                          id="user-availability"
                          :value="userAvailable"
                          class="availability-check"
                          size="mini"
                          @input="changeUserAvailability"/>
                      </div>
                    </li>
                  </ul>
                </div>
                <ul class="mobile-menu-list mt-3">
                  <template v-if="businessNav">
                    <router-link
                      :to="{name: 'Chat'}"
                      tag="li"
                      active-class="active"
                      class="list-item chat"
                      @click.native="closeMobileMenu">Chat</router-link>
                    <router-link
                      :to="{name: 'Notifications'}"
                      tag="li"
                      active-class="active"
                      class="list-item notifications"
                      @click.native="closeMobileMenu">Notifications</router-link>
                    <router-link
                      :to="{name: 'Automation'}"
                      tag="li"
                      active-class="active"
                      class="list-item automation"
                      @click.native="closeMobileMenu">Automation</router-link>
                    <router-link
                      :to="{name: 'Contacts'}"
                      tag="li"
                      active-class="active"
                      class="list-item contacts"
                      @click.native="closeMobileMenu">Contacts</router-link>
                    <!--<router-link
                      :to="{ name: 'Payments' }"
                      tag="li"
                      active-class="active"
                      class="list-item payments"
                      @click.native="closeMobileMenu">Payments</router-link>-->
                    <router-link
                      :to="{name: 'Analytics'}"
                      tag="li"
                      active-class="active"
                      class="list-item analytics"
                      @click.native="closeMobileMenu">Analytics</router-link>
                    <router-link
                      :to="{ name: 'BusinessSettings', params: { back_to: $route.path }}"
                      tag="li"
                      active-class="active"
                      class="list-item settings"
                      @click.native="closeMobileMenu">Settings</router-link>
                    <router-link
                      :to="{name: 'BusinessList'}"
                      tag="li"
                      active-class="active"
                      class="list-item d-lg-none d-xl-none businesses"
                      @click.native="closeMobileMenu">My Businesses</router-link>
                  </template>
                  <router-link
                    :to="{name: 'Settings', params: {back_to: $route.path}}"
                    tag="li"
                    active-class="active"
                    class="list-item d-lg-none d-xl-none account"
                    @click.native="closeMobileMenu">Account</router-link>
                  <li
                    class="list-item d-lg-none d-xl-none logout"
                    @click="logout">
                    Log out
                  </li>
                </ul>
              </scroll-area>
            </nav>
          </b-col>
          <b-col
            v-if="!businessNav"
            cols="3"
            sm="2"
            class="ml-auto px-0 d-none d-lg-block">
            <UserDropdown
              :availability-toggle-shown="false"/>
          </b-col>
          <b-col
            cols="3"
            sm="2"
            class="ml-auto menu-toggle d-lg-none">
            <div
              class="menu-toggle-button"
              @click.stop="toggleMobileMenu">
              <img src="~@/assets/img/menu-button.svg">
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-navbar>
    <BusinessMenuColumn v-if="businessNav"/>
    <ConnectionLostModal ref="connectionLostModal"/>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ClickOutside from 'v-click-outside';
import UserAvailabilityMixin from '@/mixins/UserAvailability';
import BusinessMenuColumn from '@/components/common/BusinessMenuColumn';
import ConnectionLostModal from './modals/ConnectionLostModal';
import SwitchCheckbox from './SwitchCheckbox';
import BusinessSubmenu from './partials/BusinessSubmenu';
import UserDropdown from './UserDropdown';
import ScrollArea from './ScrollArea';

export default {
  name: 'AppHeader',
  directives: {
    ClickOutside: ClickOutside.directive,
  },
  components: {
    ScrollArea,
    BusinessMenuColumn,
    BusinessSubmenu,
    UserDropdown,
    ConnectionLostModal,
    SwitchCheckbox,
  },
  mixins: [
    UserAvailabilityMixin,
  ],
  props: {
    businessNav: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mobileMenuOpened: false,
      userSubmenuOpened: false,
    };
  },
  computed: {
    ...mapGetters({
      echoConnectionLost: 'pusher/echoConnectionLost',
    }),
  },
  watch: {
    echoConnectionLost(connectionLost) {
      if (connectionLost) {
        this.$refs.connectionLostModal.show();
      } else {
        this.$refs.connectionLostModal.hide();
      }
    },
  },
  mounted() {
    this.trackEchoConnection();
  },
  methods: {
    ...mapActions({
      trackEchoConnection: 'pusher/trackEchoConnection',
      logout: 'user/logout',
    }),
    toggleMobileMenu() {
      this.mobileMenuOpened = !this.mobileMenuOpened;
    },
    closeMobileMenu() {
      this.mobileMenuOpened = false;
    },
    toggleBusinessSubmenu() {
      this.businessSubmenuOpened = !this.businessSubmenuOpened;
    },
    toggleUserSubmenu() {
      this.userSubmenuOpened = !this.userSubmenuOpened;
    },
  },
};
</script>
